"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = EnrollmentOpportunityMessage;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const Theme_1 = require("../Theme");
const Message_1 = __importDefault(require("../components/Message"));
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const cancelable_promise_1 = require("cancelable-promise");
const Benefits_1 = __importDefault(require("../api/Benefits"));
const UserContext_1 = require("../contexts/UserContext");
const SingleSignOn_1 = require("../shared/SingleSignOn");
const react_i18next_1 = require("react-i18next");
const Animatable = __importStar(require("react-native-animatable"));
const FirebaseAnalytics_1 = __importDefault(require("../shared/FirebaseAnalytics"));
const ResponsiveContext_1 = require("../contexts/ResponsiveContext");
const ThemeContext_1 = require("../ThemeContext");
function EnrollmentOpportunityMessage(props) {
    const THEME = (0, ThemeContext_1.useTheme)();
    const { t } = (0, react_i18next_1.useTranslation)();
    const userContext = react_1.default.useContext(UserContext_1.UserContext);
    const { size } = (0, ResponsiveContext_1.useResponsiveContext)();
    const promise = react_1.default.useRef(null);
    const [enrollmentInfo, setEnrollmentInfo] = react_1.default.useState(null);
    const refresh = react_1.default.useCallback(() => {
        promise.current?.cancel();
        promise.current = (0, cancelable_promise_1.cancelable)(userContext.getToken()
            .then(token => Benefits_1.default.getEnrollmentStatus(token)))
            .then(data => {
            if (data != null) {
                setEnrollmentInfo(data);
            }
        })
            .catch(e => {
            console.error(e);
        });
    }, []);
    react_1.default.useEffect(() => {
        refresh();
        return () => promise.current?.cancel();
    }, [refresh]);
    return ((enrollmentInfo?.isOpen) &&
        (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { marginTop: props.topSpace ? 6 : 0 }, children: (0, jsx_runtime_1.jsx)(Animatable.View, { animation: enrollmentInfo.isEditable ? '' : 'pulse', iterationCount: 2, delay: 500, direction: "alternate", children: (0, jsx_runtime_1.jsx)(Message_1.default, { indicator: 'none', important: true, degrade: enrollmentInfo.isEditable, onActionStart: () => {
                        FirebaseAnalytics_1.default.LogEvent('feature_used', {
                            'feature': 'Prism SSO - Benefits Enrollment',
                            'client': userContext.client?.id,
                            'employee': userContext.employee?.employeeId
                        });
                        SingleSignOn_1.SingleSignOn.Perform({
                            navigation: props.navigation,
                            client: userContext?.client?.id,
                            provider: 'prism',
                            additionalRouting: 'BENEFITS',
                            title: t('myBenefits:labels.benefitsEnrollment')
                        });
                    }, imageLeft: size != 'sm' &&
                        (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { color: THEME.AlwaysWhite, icon: Theme_1.ICONS.Regular.CircleExclamation, size: 24, style: { marginLeft: 8, marginRight: 16 } }), imageRight: (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { color: THEME.AlwaysWhite, icon: Theme_1.ICONS.Regular.ArrowUpRightFromSquare, size: size != 'sm' ? 24 : 20, style: { marginLeft: 12, marginRight: 4 } }), content: (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { marginLeft: size != 'sm' ? 0 : 6 }, children: [(0, jsx_runtime_1.jsx)(react_native_1.Text, { style: {
                                    color: THEME.AlwaysWhite,
                                    fontWeight: '700',
                                    fontSize: 18,
                                }, children: t('myBenefits:labels.benefitsEnrollment') }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { accessible: false, style: {
                                    color: THEME.AlwaysWhite,
                                    fontWeight: '500',
                                    fontSize: 14,
                                }, children: ((type) => {
                                    if (enrollmentInfo.isEditable) {
                                        return t('myBenefits:text.modifyEnrollment');
                                    }
                                    else {
                                        switch (type) {
                                            case 'Life Event': return t("myBenefits:text.oeLifeEvent");
                                            case 'Anytime Enrollment': return t("myBenefits:text.oeAnytime");
                                            case 'Open Enrollment': return t("myBenefits:text.oeOpen");
                                            case 'Benefits Enrollment': return t('myBenefits:text.oeStandard');
                                            default: return t('myBenefits:text.oeOpen');
                                        }
                                    }
                                })(enrollmentInfo?.enrollmentType) })] }) }) }) }));
}
;
